import BuildingBar from './BuildingBar';

export default BuildingBar;



// WEBPACK FOOTER //
// ./src/components/Building/Chess/BuildingBar/index.js